import { useQuery } from '@tanstack/react-query';
import { scanApi } from '@/services/api';

export function useExpiringDomains() {
  return useQuery({
    queryKey: ['expiring-domains'],
    queryFn: () => scanApi.getExpiringDomains(),
    staleTime: 10 * 60_000,
  });
}
